export const fr = {
  // Navbar
  nav: {
    home: "Accueil",
    about: "À propos",
    expertise: "Expertise",
    services: "Nos services",
    methodology: "Méthodologie",
    employeMystere: "Employé Mystère",
    cities: "Nos villes",
    blog: "Blog",
    faq: "FAQ",
    contact: "Contact",
    cta: "Demander un audit",
  },

  // Footer
  footer: {
    navigation: "Navigation",
    ourCities: "Nos villes",
    contactTitle: "Contact",
    allCities: "Toutes les villes →",
    tagline: "Cabinet spécialisé en audits mystère et employé mystère pour toute entreprise qui emploie des salariés : industrie, retail, logistique, bureaux, santé.",
    motto: "Discrétion · Rigueur · Excellence",
    rights: "Employé Incognito — Tous droits réservés",
    legal: "Mentions légales",
    privacy: "Politique de confidentialité",
    whatsapp: "(WhatsApp)",
  },

  // Contact form
  form: {
    firstName: "Prénom *",
    lastName: "Nom *",
    establishment: "Nom de l'établissement *",
    function: "Fonction",
    email: "Email professionnel *",
    phone: "Téléphone",
    typeLabel: "Type d'établissement *",
    stars: "Nombre d'étoiles (si hôtel)",
    location: "Localisation (ville, pays)",
    message: "Décrivez votre besoin en détail *",
    consent: "J'accepte que mes données soient traitées conformément à la politique de confidentialité de Employé Incognito dans le cadre de ma demande. *",
    submit: "Demandez votre audit personnalisé",
    sending: "Envoi en cours…",
    successTitle: "Demande envoyée avec succès",
    successText: "Un expert vous recontactera sous",
    successDelay: "24 à 48 heures",
    errorText: "Une erreur est survenue. Veuillez réessayer ou nous contacter directement.",
    types: [
      "Hôtel",
      "Restaurant",
      "Resort / Spa",
      "Agence de voyage",
      "Location premium",
      "Établissement touristique",
      "Groupe hôtelier",
      "Commerce / Retail",
      "Banque / Assurance",
      "Santé / Clinique",
      "Administration / Collectivité",
      "Entreprise / Corporate",
      "Autre",
    ],
  },

  // Homepage
  home: {
    badge: "Cabinet d'immersion opérationnelle — Tous secteurs",
    heroTitle: "Nous devenons vos employés pour révéler la",
    heroHighlight: "réalité de votre entreprise",
    heroDesc: "Employé Incognito réalise des immersions terrain discrètes pour identifier les dysfonctionnements invisibles, écarts de process, problématiques managériales et opportunités d'amélioration. Audit interne, employé mystère, observation opérationnelle — tous secteurs d'activité.",
    videoSubtitle: "L'audit qui commence de l'intérieur",
    videoTitle: "Voir ce que personne ne vous dit",
    videoDesc: "L'immersion révèle ce que les tableaux de bord, audits classiques et reportings ne voient pas.",
    sectorsSubtitle: "Tous secteurs d'activité",
    sectorsTitle: "Nos domaines d'intervention",
    sectorsDesc: "Usine, magasin, entrepôt, bureau, clinique ou agence : dès qu'il y a des salariés, il y a un écart entre ce que voit la direction et ce que vivent les équipes. C'est là que nous intervenons.",
    sectorsList: [
      { title: "Industrie & Production", desc: "Usines, ateliers, sites de production : sécurité réelle, organisation, cadence et climat social." },
      { title: "Retail & Réseaux", desc: "Magasins, franchises, concessions, grande distribution." },
      { title: "Logistique & Entrepôts", desc: "Plateformes, préparation de commandes, transport, supply chain." },
      { title: "Bureaux & Services", desc: "PME, sièges sociaux, cabinets, agences, sociétés multisites." },
      { title: "Santé & Médico-social", desc: "Cliniques, centres médicaux, EHPAD, établissements spécialisés." },
      { title: "Relation client & BTP", desc: "Centres d'appel, chantiers, équipes terrain et itinérantes." },
    ],
    trustItems: ["Tous secteurs avec salariés", "Missions 100 % confidentielles", "Rapport sous 7 jours"],
    gapSubtitle: "L'angle mort du dirigeant",
    gapTitle: "Ce que vous voyez. Ce que vos salariés vivent.",
    gapLeftTitle: "Vue de la direction",
    gapRightTitle: "Ce que découvre notre employé",
    gapLeft: ["Des reportings au vert", "Des procédures écrites et validées", "Des managers qui « gèrent »", "Un turnover jugé « normal »"],
    gapRight: ["Des contournements quotidiens des process", "Des consignes jamais appliquées sur le terrain", "Un management qui démotive en silence", "Des départs qui coûtent cher et s'expliquent"],
    concerneSubtitle: "Diagnostic",
    concerneTitle: "Votre entreprise est concernée si…",
    concerneItems: [
      "vos reportings disent « tout va bien » mais vous avez des doutes.",
      "vous suspectez des écarts entre procédures et réalité terrain.",
      "vous gérez plusieurs sites, agences, magasins ou franchises.",
      "vous avez du turnover ou des tensions internes inexpliquées.",
      "vous voulez comprendre ce que vivent réellement vos équipes.",
      "vous cherchez une vision non filtrée de votre organisation.",
    ],
    concerneCta: "Demander une immersion",
    casesSubtitle: "Cas d'usage",
    casesTitle: "Exemples d'immersions réelles",
    cases: [
      { sector: "Retail", title: "Intégration en magasin", desc: "Nous intégrons votre point de vente comme vendeur pour analyser posture commerciale, ventes perdues, qualité client et respect des procédures." },
      { sector: "Industrie", title: "Immersion sur site de production", desc: "Nous rejoignons vos équipes terrain pour observer sécurité réelle, organisation, communication interne et écarts opérationnels." },
      { sector: "Bureaux", title: "Observation en entreprise", desc: "Immersion dans vos équipes pour analyser management réel, culture interne, processus et efficacité organisationnelle." },
      { sector: "Logistique", title: "Immersion en entrepôt", desc: "Nous devenons préparateur ou cariste pour mesurer cadences, sécurité, pertes de temps et relations avec l'encadrement." },
    ],
    ctaPrimary: "Demandez votre audit personnalisé",
    ctaSecondary: "Découvrir nos services",
    whoWeAre: "Qui sommes-nous",
    whoWeAreTitle: "Le cabinet d'immersion pour toute entreprise qui emploie",
    whoWeAreDesc: "Employé Incognito est le partenaire des dirigeants qui veulent connaître la vérité du terrain. Nos auditeurs s'intègrent comme de vrais salariés, dans tout type d'entreprise, pour révéler ce que les reportings ne montrent pas : organisation réelle, management, climat social et rentabilité.",
    values: ["Discrétion absolue", "Tous secteurs", "Résultats mesurables"],
    valueDescs: [
      "Nos auditeurs interviennent en toute confidentialité, comme de vrais salariés.",
      "Industrie, retail, logistique, bureaux, santé, BTP… dès qu'il y a des salariés.",
      "Des rapports stratégiques avec des indicateurs de performance concrets.",
    ],
    expertiseSubtitle: "Nos expertises",
    expertiseTitle: "Des audits terrain sur mesure",
    services: [
      { title: "Employé Mystère en immersion", desc: "Un auditeur intégré dans vos équipes comme un salarié pour observer la réalité opérationnelle." },
      { title: "Audit climat social & management", desc: "Relations hiérarchiques, motivation, causes réelles du turnover et des tensions internes." },
      { title: "Audit process & conformité", desc: "Écarts entre procédures écrites et pratiques réelles : sécurité, qualité, productivité." },
      { title: "Rapports Stratégiques", desc: "Score de performance, analyse approfondie et plan d'amélioration actionnable." },
    ],
    seeAllServices: "Voir tous nos services",
    advantages: [
      { num: "100%", label: "Immersion totale, aucun filtre" },
      { num: "24-48h", label: "Délai de réponse garanti" },
      { num: "360°", label: "Vision interne & externe complète" },
      { num: "∞", label: "Tous secteurs d'activité" },
    ],
    testimonialsSubtitle: "Témoignages",
    testimonialsTitle: "La confiance de nos clients",
    testimonials: [
      { quote: "En trois semaines, leur auditeur a vu ce que nos reportings cachaient depuis deux ans. Un électrochoc salutaire.", author: "Directeur de site", company: "Groupe industriel, Hauts-de-France" },
      { quote: "Nous avons réduit notre turnover en entrepôt de près d'un tiers grâce à leurs recommandations.", author: "DRH", company: "Logisticien national" },
      { quote: "Une rigueur et une discrétion exemplaires sur nos 40 magasins. Un partenaire stratégique.", author: "Directrice des opérations", company: "Réseau retail" },
    ],
    ctaSubtitle: "Passez à l'action",
    ctaTitle: "Être recontacté par un expert",
    ctaDesc: "Remplissez le formulaire ci-dessous et un consultant Employé Incognito vous recontactera sous 24 à 48 heures pour échanger sur vos besoins.",
    immersiveNew: "Pour toute entreprise",
    immersiveTitle: "Employé Mystère — Pour toute entreprise",
    immersiveDesc: "Notre service d'employé mystère s'adresse à toute entreprise qui souhaite comprendre sa réalité interne. Commerce, banque, santé, administration… notre auditeur s'intègre dans vos équipes pour révéler les dysfonctionnements invisibles.",
    immersiveCta: "Découvrir ce service",
    immersiveClient: "Client Mystère",
    immersiveClientDesc: "Évalue l'expérience client de l'extérieur",
    immersiveEmploye: "Employé Mystère",
    immersiveEmployeDesc: "S'infiltre dans vos équipes, tous secteurs",
    // New enterprise sectors section
    enterpriseSubtitle: "Tous les secteurs",
    enterpriseTitle: "L'employé mystère pour toute entreprise",
    enterpriseDesc: "Nous intervenons dans tous les secteurs où le fonctionnement interne impacte la performance.",
    enterpriseSectors: [
      { title: "Commerce & Retail", desc: "Évaluez l'accueil, le conseil client, le management d'équipe et le respect des procédures en magasin." },
      { title: "Banque & Assurance", desc: "Analysez la qualité de l'accueil en agence, le respect des process réglementaires et la relation client." },
      { title: "Santé & Cliniques", desc: "Observez la prise en charge des patients, la coordination des équipes soignantes et l'organisation interne." },
      { title: "Administration & Collectivités", desc: "Évaluez l'accueil du public, l'efficacité des services et la communication inter-services." },
    ],
  },

  // About page
  about: {
    seoTitle: "À propos — Cabinet d'audit mystère hôtelier",
    seoDesc: "Découvrez Employé Incognito, cabinet de conseil spécialisé en audit mystère pour l'hôtellerie, la restauration et le tourisme. Discrétion, rigueur, excellence.",
    subtitle: "À propos",
    title: "Un regard d'expert au service de l'excellence",
    desc: "Employé Incognito est un cabinet de conseil spécialisé dans l'audit mystère et l'employé mystère en immersion. Experts historiques de l'hôtellerie, la restauration et le tourisme, nous intervenons désormais dans tous les secteurs d'activité. Notre mission : révéler le potentiel d'excellence de chaque organisation.",
    missionTitle: "Notre Mission",
    missionP1: "Évaluer avec exigence et discrétion l'ensemble du parcours client et du fonctionnement interne des entreprises — hôtellerie, restauration, tourisme, commerce, banque, santé et bien d'autres — afin de fournir des analyses stratégiques permettant d'élever les standards de service.",
    missionP2: "Nous intervenons comme un regard invisible mais précis, identifiant chaque opportunité d'amélioration pour transformer l'expérience client en avantage concurrentiel.",
    visionTitle: "Notre Vision",
    visionP: "Devenir la référence incontournable de l'audit mystère dans le secteur de l'hospitalité en France et à l'international, en accompagnant les établissements vers l'excellence opérationnelle et la satisfaction client optimale.",
    valuesSubtitle: "Nos valeurs",
    valuesTitle: "Les piliers de notre engagement",
    values: [
      { title: "Discrétion", desc: "Nos auditeurs se fondent dans l'environnement, comme de véritables clients exigeants." },
      { title: "Rigueur", desc: "Chaque critère est évalué selon des grilles d'analyse précises et objectives." },
      { title: "Excellence", desc: "Nous nous alignons sur les standards internationaux de l'hôtellerie haut de gamme." },
      { title: "Analyse", desc: "Des insights stratégiques pour comprendre en profondeur l'expérience client." },
      { title: "Performance", desc: "Des recommandations concrètes et mesurables pour une amélioration continue." },
    ],
    specSubtitle: "Spécialisation",
    specTitle: "De l'hôtellerie à toute entreprise",
    specDesc: "Forts de notre expertise historique en hôtellerie et restauration haut de gamme, nous avons élargi notre savoir-faire à tous les secteurs d'activité. Notre service d'employé mystère en immersion s'adresse à toute entreprise souhaitant comprendre sa réalité interne : commerce, banque, santé, administration, industrie.",
    specCta: "Être recontacté par un expert",
  },

  // Services page
  services: {
    seoTitle: "Services — Audits immersifs tous secteurs d'activité",
    seoDesc: "Découvrez nos audits immersifs sur mesure : retail, industrie, services, santé, centres d'appel, hôtellerie & restauration. Rapports stratégiques et plans d'amélioration mesurables.",
    subtitle: "Nos services",
    title: "Des audits immersifs pour toutes les entreprises",
    desc: "Quel que soit votre secteur, nos employés incognito s'intègrent à vos équipes pour révéler la réalité du terrain. Une approche rigoureuse, discrète et adaptée à chaque organisation.",
    requestAudit: "Demander un audit",
    readySubtitle: "Prêt à commencer ?",
    readyTitle: "Révélez la réalité de votre entreprise",
    readyDesc: "Nos experts conçoivent l'immersion adaptée à votre secteur, votre taille et vos enjeux opérationnels.",
    readyCta: "Demandez votre audit personnalisé",
    list: [
      {
        title: "Audits Immersifs Multi-secteurs",
        desc: "Une immersion terrain dans tout type d'entreprise — retail, industrie, services, santé, centres d'appel, administration — pour révéler ce que les reportings ne montrent pas.",
        items: [
          "Retail & commerce (boutiques, chaînes, grande distribution)",
          "Industrie & production (ateliers, sites de fabrication)",
          "Services & entreprises B2B (sièges, agences, cabinets)",
          "Santé & médico-social (cliniques, centres, EHPAD)",
          "Centres d'appel & relation client",
          "Banque, assurance & administration publique",
        ],
      },
      {
        title: "Audits Hôtellerie & Restauration",
        desc: "Notre expertise historique : une évaluation exhaustive du parcours client en hôtellerie, restauration et tourisme haut de gamme.",
        items: [
          "Processus de réservation et accueil",
          "Qualité de la chambre, du service et de la restauration",
          "Propreté, entretien et conformité opérationnelle",
          "Techniques de vente et upselling en salle",
          "Resorts, spas, agences de voyage et conciergeries",
          "Expérience client globale et fidélisation",
        ],
      },
      {
        title: "Audits Réseaux & Multi-sites",
        desc: "Détection des écarts entre vos sites, agences ou points de vente avant qu'ils n'impactent durablement votre rentabilité et votre image.",
        items: [
          "Homogénéité des standards entre sites",
          "Application réelle des procédures et formations",
          "Qualité managériale de proximité",
          "Climat social et turnover par établissement",
          "Performance commerciale comparée",
          "Cartographie des points forts et points faibles",
        ],
      },
      {
        title: "Rapports Stratégiques",
        desc: "Des livrables complets, factuels et confidentiels pour décider et agir avec précision.",
        items: [
          "Score de performance global et par catégorie",
          "Analyse détaillée de chaque critère évalué",
          "Benchmarking sectoriel",
          "Identification des axes d'amélioration prioritaires",
          "Plan d'action stratégique personnalisé",
          "Suivi et mesure de la progression",
        ],
      },
    ],
  },

  // Methodology page
  methodology: {
    seoTitle: "Méthodologie — Processus d'audit mystère en 5 étapes",
    seoDesc: "Notre méthodologie d'audit mystère en 5 étapes : analyse des besoins, définition des critères, visite mystère, analyse et rapport stratégique personnalisé.",
    subtitle: "Notre méthodologie",
    title: "Un processus rigoureux en 5 étapes",
    desc: "Une approche structurée, éprouvée et adaptable pour garantir des résultats stratégiques et mesurables.",
    stepLabel: "Étape",
    steps: [
      { title: "Analyse des besoins", desc: "Nous échangeons avec vous pour comprendre vos objectifs, vos enjeux et les spécificités de votre établissement. Cette phase de cadrage est essentielle pour concevoir un audit sur mesure." },
      { title: "Définition des critères", desc: "Nous construisons ensemble une grille d'évaluation personnalisée, adaptée à votre positionnement et aux standards de votre secteur. Chaque critère est pondéré selon vos priorités." },
      { title: "Visite mystère", desc: "Nos auditeurs, formés aux codes de l'hospitalité haut de gamme, se présentent comme de véritables clients. Ils évaluent chaque point de contact avec objectivité et discrétion." },
      { title: "Analyse des données", desc: "Les observations sont compilées et analysées en profondeur. Nous identifions les forces, les faiblesses et les opportunités d'amélioration pour chaque critère évalué." },
      { title: "Rapport & recommandations", desc: "Vous recevez un rapport stratégique complet avec un score de performance, une analyse détaillée et un plan d'amélioration actionnable avec des recommandations prioritaires." },
    ],
    readySubtitle: "Prêt à commencer ?",
    readyTitle: "Lancez votre premier audit mystère",
    readyDesc: "Contactez-nous pour échanger avec un expert et définir ensemble l'audit adapté à votre établissement.",
    readyCta: "Être recontacté par un expert",
  },

  // Contact page
  contact: {
    seoTitle: "Contact — Demandez votre audit mystère personnalisé",
    seoDesc: "Contactez Employé Incognito pour un audit mystère hôtelier sur mesure. Réponse sous 24-48h. Email, téléphone ou formulaire de contact.",
    subtitle: "Contact",
    title: "Demandez votre audit personnalisé",
    desc: "Remplissez le formulaire ci-dessous et un consultant Employé Incognito vous recontactera sous 24 à 48 heures pour échanger sur vos besoins.",
    coordsTitle: "Coordonnées",
    emailLabel: "Email",
    phoneLabel: "WhatsApp / Téléphone",
    hqLabel: "Siège",
    hqValue: "Paris, France",
    reactivityTitle: "Réactivité",
    reactivityText: "Chaque demande est traitée avec la plus grande attention. Un expert vous recontactera sous",
    reactivityDelay: "24 à 48 heures ouvrées",
    reactivityEnd: "pour définir ensemble vos besoins.",
  },

  // FAQ page
  faq: {
    seoTitle: "FAQ — Questions Fréquentes sur les Audits Mystère & Employé Mystère",
    seoDesc: "Retrouvez les réponses à toutes vos questions sur les audits mystère et l'employé mystère : coût, déroulement, fréquence, villes d'intervention. Employé Incognito vous accompagne.",
    badge: "Questions fréquentes",
    heroTitle: "Tout savoir sur les",
    heroHighlight: "audits mystère & l'employé mystère",
    heroDesc: "Retrouvez les réponses aux questions les plus fréquentes sur nos services d'audit mystère et d'audit immersif employé mystère pour l'hôtellerie, la restauration et le tourisme.",
    goFurtherSubtitle: "Aller plus loin",
    goFurtherTitle: "Ressources utiles",
    links: [
      { title: "Nos services", desc: "Découvrez nos audits hôtel, restaurant et tourisme" },
      { title: "Notre méthodologie", desc: "Les 5 étapes de notre processus d'audit" },
      { title: "Nos villes", desc: "Plus de 20 villes couvertes en France" },
      { title: "Blog", desc: "Articles et conseils sur l'expérience client" },
      { title: "Audit hôtel Paris", desc: "Audit mystère dans la capitale" },
      { title: "Contactez-nous", desc: "Devis gratuit sous 24-48h" },
    ],
    notListedSubtitle: "Votre question n'est pas listée ?",
    notListedTitle: "Contactez-nous directement",
    notListedDesc: "Un consultant Employé Incognito vous répondra sous 24 à 48 heures.",
    notListedCta: "Nous contacter",
    items: [
      { question: "Qu'est-ce qu'un audit mystère ?", answer: "Un audit mystère (ou mystery shopping) consiste à envoyer un évaluateur anonyme dans votre établissement pour vivre l'expérience client de A à Z. L'auditeur se comporte comme un vrai client et évalue chaque étape : réservation, accueil, service, chambre, restauration, check-out. Un rapport détaillé avec un score de performance et des recommandations concrètes vous est ensuite remis." },
      { question: "Combien coûte un audit mystère pour un hôtel ?", answer: "Le tarif d'un audit mystère varie selon le type d'établissement, le nombre de critères évalués et la durée de la mission. Employé Incognito propose des audits sur mesure adaptés à chaque budget. Contactez-nous pour recevoir un devis personnalisé gratuit sous 24 à 48 heures." },
      { question: "Comment se déroule un audit mystère avec Employé Incognito ?", answer: "Notre méthodologie se déroule en 5 étapes : 1) Analyse de vos besoins et objectifs, 2) Définition des critères d'évaluation personnalisés, 3) Visite mystère par un auditeur formé, 4) Analyse approfondie des données collectées, 5) Remise d'un rapport stratégique avec score de performance et plan d'amélioration actionnable." },
      { question: "Quels types d'établissements peuvent bénéficier d'un audit mystère ?", answer: "Employé Incognito intervient dans l'hôtellerie (de 3 à 5 étoiles et palaces), la restauration (gastronomique, bistronomique, brasseries), les resorts et spas, les agences de voyage et le tourisme haut de gamme. Grâce à notre service d'employé mystère, nous intervenons également dans le commerce, la banque, la santé, l'administration et toute entreprise souhaitant évaluer son fonctionnement interne." },
      { question: "L'audit mystère est-il vraiment anonyme ?", answer: "Oui, la discrétion absolue est au cœur de notre démarche. Nos auditeurs sont des professionnels formés qui se comportent exactement comme des clients ordinaires. Aucun membre de votre personnel n'est prévenu de la visite. C'est cette authenticité qui garantit la fiabilité de nos évaluations." },
      { question: "Dans quelles villes intervenez-vous ?", answer: "Employé Incognito intervient dans plus de 20 grandes villes françaises : Paris, Lyon, Marseille, Bordeaux, Nice, Cannes, Monaco, Toulouse, Strasbourg, Lille, Nantes, Montpellier, Courchevel, Megève, Deauville, Biarritz, Aix-en-Provence, Annecy, Toulon, La Rochelle, Saint-Tropez, et bien d'autres. Nous nous déplaçons partout en France et à l'international sur demande." },
      { question: "Quelle est la différence entre un audit mystère et un audit qualité classique ?", answer: "Contrairement à un audit qualité classique (annoncé et basé sur des normes), l'audit mystère évalue l'expérience réelle du client, sans que le personnel soit prévenu. Il mesure la perception subjective, les émotions, l'attention aux détails et la cohérence du service. C'est le seul outil capable de capturer la réalité complète de l'expérience client." },
      { question: "À quelle fréquence faut-il réaliser des audits mystère ?", answer: "Nous recommandons un programme de suivi continu plutôt que des évaluations ponctuelles. Un minimum de 2 à 4 audits par an permet de mesurer les progrès, d'identifier les régressions saisonnières et d'accompagner vos équipes dans la durée. La fréquence idéale dépend de la taille de votre établissement et de vos objectifs." },
      { question: "Comment les résultats d'un audit mystère améliorent-ils les avis en ligne ?", answer: "Les avis négatifs résultent souvent d'une accumulation de micro-déceptions invisibles au quotidien. L'audit mystère identifie précisément ces points faibles avant qu'ils n'impactent vos avis sur TripAdvisor, Google ou Booking. Nos clients constatent en moyenne une amélioration de 15 à 25% de leur score de satisfaction après un programme d'audits." },
      { question: "Combien de temps faut-il pour recevoir le rapport d'audit ?", answer: "Le rapport stratégique complet est remis sous 5 à 10 jours ouvrés après la visite mystère. Il comprend un score de performance global, une analyse détaillée par critère, des comparaisons avec les standards du secteur et un plan d'amélioration concret avec des actions prioritaires." },
      { question: "Qu'est-ce que l'employé mystère ?", answer: "L'employé mystère est un audit immersif dans lequel un auditeur Employé Incognito est intégré temporairement dans votre équipe (réceptionniste, serveur, commis…) avec l'accord de la direction. Il observe de l'intérieur l'organisation, la communication entre équipes, la qualité du management, le respect des standards et la pression opérationnelle. Ce service révèle les dysfonctionnements invisibles pour la direction." },
      { question: "Quelle est la différence entre client mystère et employé mystère ?", answer: "Le client mystère évalue l'expérience côté client : accueil, service, ambiance, qualité perçue. L'employé mystère, lui, s'immerge dans les équipes pour analyser la réalité interne : management, cohésion, respect des procédures, pression opérationnelle. Les deux approches combinées offrent une vision à 360° de votre établissement." },
      { question: "Comment se déroule une mission d'employé mystère ?", answer: "La mission se déroule en 5 étapes : 1) Définition du poste et des objectifs avec la direction, 2) Immersion discrète de l'auditeur dans l'équipe, 3) Observation terrain des pratiques et de l'organisation, 4) Rédaction d'un rapport confidentiel détaillé, 5) Présentation de recommandations stratégiques pour améliorer le fonctionnement interne et renforcer l'excellence opérationnelle." },
    ],
  },

  // Blog page
  blog: {
    seoTitle: "Blog — Expertise Client Mystère & Hôtellerie de Luxe",
    seoDesc: "Articles d'expertise sur le client mystère, les audits hôteliers, la restauration haut de gamme et le tourisme de luxe. Conseils et analyses par Employé Incognito.",
    subtitle: "Blog & Ressources",
    title: "Expertise en audit mystère et hôtellerie de luxe",
    desc: "Retrouvez nos articles d'analyse, nos conseils d'experts et nos décryptages des tendances du secteur hôtelier, de la restauration et du tourisme haut de gamme.",
    ctaSubtitle: "Passez à l'action",
    ctaTitle: "Prêt à évaluer votre expérience client ?",
    ctaDesc: "Nos experts sont à votre disposition pour discuter de vos enjeux et vous proposer un audit sur mesure.",
    ctaCta: "Demandez votre audit personnalisé",
    readTime: "de lecture",
    relatedArticles: "Articles connexes",
    backToBlog: "Retour au blog",
    requestAudit: "Demandez votre audit",
    discoverCities: "Découvrez nos audits par ville",
    allCities: "Toutes les villes →",
    breadcrumbHome: "Accueil",
  },

  // Cities page
  cities: {
    seoTitle: "Audit Mystère dans toute la France",
    seoDesc: "Employé Incognito intervient dans toutes les grandes villes de France : Paris, Lyon, Cannes, Monaco, Courchevel... Découvrez nos audits mystère locaux.",
    badge: "Nos implantations",
    heroTitle: "Audit mystère dans toute la",
    heroHighlight: "France",
    heroDesc: "Employé Incognito intervient dans plus de 20 villes françaises. Découvrez nos services d'audit mystère adaptés à chaque destination.",
    notListedSubtitle: "Votre ville n'est pas listée ?",
    notListedTitle: "Nous intervenons partout en France",
    notListedDesc: "Contactez-nous pour discuter de vos besoins. Employé Incognito se déplace dans toute la France et à l'international.",
    notListedCta: "Contactez-nous",
  },

  // City page
  cityPage: {
    breadcrumbHome: "Accueil",
    breadcrumbCities: "Nos villes",
    requestAudit: "Demander un audit à",
    servicesAt: "Nos services à",
    customAuditsFor: "Audits mystère sur mesure pour",
    hotelAudit: "Audit Hôtelier à",
    restaurantAudit: "Audit Restaurant à",
    tourismAudit: "Audit Tourisme à",
    whySubtitle: "Pourquoi un audit mystère",
    whyTitle: "Pourquoi choisir Employé Incognito à",
    resourcesSubtitle: "Ressources",
    resourcesTitle: "Articles en lien avec votre démarche",
    ctaSubtitle: "Passez à l'action",
    ctaTitle: "Planifiez votre audit mystère à",
    ctaDesc1: "Contactez-nous pour discuter de vos besoins spécifiques à",
    ctaDesc2: "Un consultant Employé Incognito vous répondra sous 24 à 48 heures.",
    ctaQuote: "Demander un devis gratuit",
    ctaServices: "Découvrir nos services",
    otherSubtitle: "Nos autres destinations",
    otherTitle: "Découvrez nos audits dans d'autres villes",
    allCities: "Voir toutes les villes",
  },

  // Employé Mystère
  employeMystere: {
    seoTitle: "Employé Mystère — Audit Immersif pour toute entreprise | Employé Incognito",
    seoDesc: "Notre service d'employé mystère s'adresse à toute entreprise : hôtellerie, commerce, banque, santé, administration. Un auditeur intégré dans votre équipe pour révéler la réalité interne.",
    badge: "Pour toute entreprise",
    heroTitle: "Révélez la réalité interne de votre entreprise…",
    heroHighlight: "sans filtre.",
    heroDesc: "Notre service d'employé mystère place un auditeur au cœur de vos équipes — hôtellerie, commerce, banque, santé ou administration — pour révéler la réalité opérationnelle invisible depuis la direction.",
    ctaPrimary: "Demander un audit immersif",
    ctaSecondary: "Nos autres services",
    conceptSubtitle: "Le concept",
    conceptTitle: "L'employé mystère pour toute entreprise",
    conceptP1: "Un auditeur Employé Incognito est intégré temporairement dans votre équipe — vendeur, agent d'accueil, collaborateur — avec l'accord de la direction. Il observe de l'intérieur l'organisation, la communication entre équipes, la qualité du management et le respect des standards.",
    conceptP2: "Inspiré du concept de « patron incognito », cette approche unique s'applique à tous les secteurs d'activité : hôtellerie, commerce, banque, santé, administration, industrie. Elle révèle ce que les audits classiques ne peuvent pas voir.",
    visionClient: "Client Mystère",
    visionClientDesc: "Évalue l'expérience client de l'extérieur",
    visionEmploye: "Employé Mystère",
    visionEmployeDesc: "Révèle la réalité interne de l'intérieur",
    benefitsSubtitle: "Les bénéfices",
    benefitsTitle: "Ce que l'audit immersif révèle",
    benefits: [
      { title: "Dysfonctionnements internes", desc: "Identifiez les failles invisibles pour la direction : processus défaillants, goulots d'étranglement, pertes de temps." },
      { title: "Pertes de qualité de service", desc: "Détectez les écarts entre les standards définis et la réalité du terrain au quotidien." },
      { title: "Problèmes d'organisation", desc: "Analysez la répartition des tâches, la coordination inter-services et la gestion des priorités." },
      { title: "Cohésion des équipes", desc: "Évaluez la communication interne, l'entraide et l'ambiance de travail réelle." },
      { title: "Excellence opérationnelle", desc: "Renforcez vos standards en alignant la réalité terrain avec votre vision de l'excellence." },
    ],
    processSubtitle: "Le déroulement",
    processTitle: "Une mission en 5 étapes",
    stepLabel: "Étape",
    steps: [
      { title: "Immersion discrète", desc: "Notre auditeur intègre votre équipe sous une identité convenue avec la direction. Aucun membre du personnel n'est informé de sa véritable mission." },
      { title: "Observation terrain", desc: "Pendant plusieurs jours, l'auditeur vit le quotidien de votre établissement : rythmes, contraintes, interactions, pression opérationnelle." },
      { title: "Analyse des pratiques", desc: "Chaque observation est documentée selon notre grille d'évaluation : management, communication, respect des standards, organisation." },
      { title: "Rapport confidentiel", desc: "Un rapport détaillé et strictement confidentiel est remis à la direction avec les constats objectifs de l'immersion." },
      { title: "Recommandations stratégiques", desc: "Des préconisations concrètes et priorisées pour transformer les points faibles en leviers de performance." },
    ],
    premiumQuote: "Employé Incognito révèle ce que les indicateurs ne montrent pas.",
    premiumAuthor: "Employé Incognito",
    ctaSubtitle: "Passez à l'action",
    ctaTitle: "Demandez votre audit immersif",
    ctaDesc: "Remplissez le formulaire ci-dessous et un consultant Employé Incognito vous recontactera sous 24 à 48 heures pour échanger sur votre projet d'audit immersif.",
  },

  // 404 page
  notFound: {
    title: "Page non trouvée",
    desc: "La page que vous recherchez n'existe pas ou a été déplacée. Retournez à l'accueil pour continuer votre navigation.",
    backHome: "Retour à l'accueil",
    contact: "Contactez-nous",
  },

  // WhatsApp
  whatsapp: {
    message: "Bonjour, je souhaite obtenir des informations sur vos audits mystère.",
    label: "Nous contacter sur WhatsApp",
  },
};
